module.exports = __webpack_public_path__ + "img/preview-1.44df5b99.png";